import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";

const spinKeyframes = `
@keyframes otp-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes otp-fade-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

class OtpPopup extends Component {

  constructor(props) {

    super(props);

    this.state = {
      otp: "",
      disabled: true,
      timer: 180,
      uiState: "default",
      toggleIconForOtp: "fa fa-eye-slash",
      parsedErrors: {
        otp: "",
      },
      successMessage: "",
      errorMessage: "",
      iconLoading: true,
    };
  }

  componentDidMount() {

    this.injectKeyframes();

    setTimeout(() => {

      this.setState({
        iconLoading: false,
      });

      this.startTimer();

    }, 3000);

  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  injectKeyframes = () => {

    if (!document.getElementById("otp-keyframes")) {

      const style = document.createElement("style");

      style.id = "otp-keyframes";

      style.innerHTML = spinKeyframes;

      document.head.appendChild(style);

    }

  };

  startTimer = () => {

    clearInterval(this.interval);

    this.interval = setInterval(() => {

      this.setState((prevState) => {

        if (prevState.timer <= 1) {

          clearInterval(this.interval);

          return {
            timer: 0,
          };

        }

        return {
          timer: prevState.timer - 1,
        };

      });

    }, 1000);

  };

  formatTime = (time) => {

    const minutes = Math.floor(time / 60);

    const seconds = time % 60;

    return `${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;

  };

  handelValidateOtp = (e, value) => {

    if (e.target.name === "otp" && value.length !== 0) {

      const otpValue = value.replace(/[^0-9]/g, "");

      this.setState(
        {
          otp: otpValue,

          parsedErrors: {
            otp:
              otpValue.length > 0 &&
                otpValue.length < 6
                ? "Please enter valid 6 digit OTP"
                : "",
          },
        },

        () => {

          this.setState({
            disabled:
              this.state.otp.length !== 6,
          });

        }
      );

    } else {

      this.setState({
        otp: "",
        disabled: true,
      });

    }

  };

  toggleForOtp = () => {

    this.setState((prevState) => ({
      toggleTypeForOtp:
        prevState.toggleTypeForOtp === "password"
          ? "text"
          : "password",

      toggleIconForOtp:
        prevState.toggleTypeForOtp === "password"
          ? "fa fa-fw fa-eye"
          : "fa fa-eye-slash",
    }));

  };

  // handleSubmit = () => {

  //   if (this.state.disabled) return;

  //   this.setState({
  //     uiState: "loading",
  //     parsedErrors: {
  //       otp: "",
  //     },
  //   });

  //   if (this.props.onSubmit) {

  //     this.props.onSubmit(

  //       this.state.otp,

  //       (json) => {

  //         console.log("SUCCESS JSON", json);

  //         this.setState({
  //           uiState: "success",

  //           successMessage:

  //             (json &&
  //               (
  //                 json.message ||
  //                 json.statusMessage ||
  //                 json.msg ||
  //                 json.responseMessage
  //               )
  //             )

  //             ||

  //             "Verification completed successfully",
  //         });

  //         setTimeout(() => {

  //           if (this.props.onClose) {
  //             this.props.onClose();
  //           }

  //         }, 1500);

  //       },

  //       // (json) => {

  //       //   console.log("ERROR JSON", json);

  //       //   this.setState({
  //       //     uiState: "error",

  //       //     errorMessage:

  //       //       (json &&
  //       //         (
  //       //           json.message ||
  //       //           json.statusMessage ||
  //       //           json.msg ||
  //       //           json.responseMessage
  //       //         )
  //       //       )

  //       //       ||

  //       //       "Error occurred",
  //       //   });

  //       //   setTimeout(() => {

  //       //     this.setState({
  //       //       uiState: "default",
  //       //       otp: "",
  //       //       disabled: true,
  //       //       errorMessage: "",
  //       //       parsedErrors: {
  //       //         otp: "",
  //       //       },
  //       //     });

  //       //   }, 2000);

  //       // },

  //     );

  //   }

  // };

  handleSubmit = () => {

    if (this.state.disabled) return;

    this.setState({
      uiState: "loading",
      parsedErrors: {
        otp: "",
      },
    });

    if (this.props.onSubmit) {

      this.props.onSubmit(

        this.state.otp,

        (json) => {

          console.log("SUCCESS JSON", json);

          this.setState({
            uiState: "success",

            successMessage:

              (json &&
                (
                  json.message ||
                  json.statusMessage ||
                  json.msg ||
                  json.responseMessage
                )
              )

              ||

              "Verification completed successfully",
          });

          setTimeout(() => {

            if (this.props.onClose) {
              this.props.onClose();
            }

          }, 1500);

        },

        (json) => {

          console.log("ERROR JSON", json);

          this.setState({
            uiState: "default",
            otp: "",
            disabled: true,
            parsedErrors: {
              otp: "",
            },
          });

        },

      );

    }

  };
  handleClose = () => {

    if (this.props.onClose) {
      this.props.onClose();
    }

  };

  handleResend = () => {

    this.setState({
      iconLoading: true,
      timer: 180,
      otp: "",
      disabled: true,
      parsedErrors: {
        otp: "",
      },
    });

    clearInterval(this.interval);

    setTimeout(() => {

      this.setState({
        iconLoading: false,
      });

      this.startTimer();

    }, 3000);

    if (this.props.handleRequestOtp) {
      this.props.handleRequestOtp(true);
    }

  };

  render() {

    if (!this.props.open) return null;

    console.log("ERROR MESSAGE", this.state.errorMessage);

    const timer = this.state.timer;

    const s = {

      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.58)",
        backdropFilter: "blur(6px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "12px",
        boxSizing: "border-box",
      },

      modal: {
        width: "100%",
        maxWidth: window.innerWidth < 480 ? "95%" : "430px",
        minWidth: "280px",
        background: "#fff",
        borderRadius: "24px",
        padding: window.innerWidth < 480 ? "22px 16px" : "34px 28px",
        position: "relative",
        boxSizing: "border-box",
        animation: "otp-fade-in 0.25s ease",
        margin: "16px",
        boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
        overflow: "hidden",
      },

      iconCircle: {
        width: window.innerWidth < 480 ? 64 : 74,
        height: window.innerWidth < 480 ? 64 : 74,
        borderRadius: "50%",
        background: "linear-gradient(135deg,#EEF5FF,#DCEBFF)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 18px",
        boxShadow: "0 10px 25px rgba(0,127,255,0.14)",
      },

      title: {
        textAlign: "center",
      },

      otpFieldWrap: {
        position: "relative",
        width: "100%",
        marginTop: "10px",
      },

      otpInputStyle: {
        textAlign: "center",
        fontSize: window.innerWidth < 480 ? "18px" : "22px",
        fontWeight: "700",
        letterSpacing: window.innerWidth < 480 ? "5px" : "7px",
        background: "#F8FBFF",
        borderRadius: "16px",
        border: "2px solid #D6E7FF",
        height: window.innerWidth < 480 ? "52px" : "58px",
        paddingRight: "42px",
        boxSizing: "border-box",
      },

      otpFloatingStyle: {
        left: 0,
        width: "100%",
        textAlign: "center",
        color: "#6b7280",
        fontWeight: "600",
      },

      otpErrorStyle: {
        textAlign: "center",
        marginTop: "12px",
        fontSize: "12px",
        fontWeight: "700",
        color: "#ef4444",
        lineHeight: "18px",
        position: "relative",
        display: "block",
      },

      eyeIcon: {
        position: "absolute",
        top: "50%",
        right: "16px",
        cursor: "pointer",
        color: "#8a8a8a",
        fontSize: window.innerWidth < 480 ? "14px" : "16px",
        zIndex: 2,
      },

      timerRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 18,
        gap: 6,
      },

      timerText: {
        fontSize: window.innerWidth < 480 ? "13px" : "14px",
        color: timer === 0 ? "#e53935" : "#007FFF",
        fontWeight: "700",
      },

      resendRow: {
        marginTop: 14,
        fontSize: 14,
        color: "#777",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "4px",
      },

      resendBtn: {
        marginTop:"20px",
        color: "#007FFF",
        fontWeight: "700",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        fontSize: 14,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
      },

      buttonContainer: {
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        marginTop: 28,
        flexWrap: "wrap",
        flexDirection: window.innerWidth < 480 ? "column" : "row",
      },
    };

    const { uiState } = this.state;

    if (uiState === "loading") {

      return (
        <div style={s.overlay}>
          <div style={s.modal}>

            <div
              style={{
                textAlign: "center",
                padding: "30px 0",
              }}
            >

              <div
                style={{
                  width: 56,
                  height: 56,
                  margin: "0 auto 20px",
                  border: "4px solid #dbeafe",
                  borderTopColor: "#007FFF",
                  borderRadius: "50%",
                  animation: "otp-spin 0.8s linear infinite",
                }}
              />

              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#111827",
                  marginBottom: "8px",
                }}
              >
                Verifying OTP...
              </div>

              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                }}
              >
                Please wait a moment
              </div>

            </div>

          </div>
        </div>
      );

    }

    if (uiState === "success") {

      return (

        <div style={s.overlay}>

          <div style={s.modal}>

            <div
              style={{
                textAlign: "center",
                padding: "30px 0",
              }}
            >

              <div
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  background: "#E8F5E9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  animation: "otp-pop 0.45s cubic-bezier(0.34,1.56,0.64,1) forwards",
                }}
              >

                <i
                  className="fa fa-check"
                  style={{
                    fontSize: "34px",
                    color: "#43A047",
                  }}
                />

              </div>

              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#111827",
                  marginBottom: "8px",
                }}
              >
                OTP Verified
              </div>

              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                }}
              >
                {this.state.successMessage}
              </div>

            </div>

          </div>

        </div>

      );

    }

    // if (uiState === "error") {

    //   return (
    //     <div style={s.overlay}>
    //       <div style={s.modal}>

    //         <div
    //           style={{
    //             textAlign: "center",
    //             padding: "30px 0",
    //           }}
    //         >

    //           <div
    //             style={{
    //               width: 72,
    //               height: 72,
    //               borderRadius: "50%",
    //               background: "#FEECEC",
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //               margin: "0 auto 20px",
    //             }}
    //           >

    //             <i
    //               className="fa fa-times"
    //               style={{
    //                 fontSize: "34px",
    //                 color: "#E53935",
    //               }}
    //             />

    //           </div>

    //           <div
    //             style={{
    //               fontSize: "22px",
    //               fontWeight: "700",
    //               color: "#111827",
    //               marginBottom: "8px",
    //             }}
    //           >
    //             {this.state.errorMessage}
    //           </div>

    //         </div>

    //       </div>
    //     </div>
    //   );

    // }

    return (

      <div style={s.overlay}>

        <div style={s.modal}>

          {/* CLOSE */}
          <div
            style={{
              position: "absolute",
              top: "8px",
              right: "14px",
              zIndex: 9999,
            }}
          >

            <span
              onClick={this.handleClose}
              style={{
                fontSize: "30px",
                cursor: "pointer",
                color: "#8a8a8a",
              }}
            >
              &times;
            </span>

          </div>

          {/* ICON */}
          <div style={s.iconCircle}>

            {
              this.state.iconLoading ? (

                <div
                  style={{
                    width: 24,
                    height: 24,
                    border: "3px solid #c7dcff",
                    borderTopColor: "#007FFF",
                    borderRadius: "50%",
                    animation: "otp-spin 0.8s linear infinite",
                  }}
                />

              ) : (

                <i
                  className="fa fa-envelope-open-o"
                  style={{
                    fontSize: 24,
                    color: "#007FFF",
                  }}
                />

              )
            }

          </div>

          {/* TITLE */}
          <div style={s.title}>

            {
              this.state.iconLoading ? (

                <div>

                  <div
                    style={{
                      fontSize: window.innerWidth < 480 ? "18px" : "22px",
                      fontWeight: "700",
                      color: "#111827",
                      marginBottom: "10px",
                    }}
                  >
                    Processing <br /> Please wait...
                  </div>

                  <div
                    style={{
                      color: "#6b7280",
                      lineHeight: "28px",
                      fontSize: window.innerWidth < 480 ? "13px" : "15px",
                    }}
                  >
                    A One Time Password (OTP) has been sent to your registered email address{" "}

                    <span
                      style={{
                        color: "#007FFF",
                        fontWeight: "700",
                        wordBreak: "break-word",
                        display: "inline-block",
                        marginTop: "6px",
                      }}
                    >
                      {localStorage.getItem("emailID")}
                    </span>

                  </div>

                </div>

              ) : (

                <div>

                  <div
                    style={{
                      fontSize: window.innerWidth < 480 ? "20px" : "24px",
                      fontWeight: "700",
                      color: "#111827",
                      marginBottom: "12px",
                    }}
                  >
                    Verify OTP
                  </div>

                  <div
                    style={{
                      color: "#6b7280",
                      lineHeight: "28px",
                      fontSize: window.innerWidth < 480 ? "13px" : "15px",
                    }}
                  >
                    A One Time Password (OTP) has been sent to your registered email address{" "}

                    <span
                      style={{
                        color: "#007FFF",
                        fontWeight: "700",
                        wordBreak: "break-word",
                        display: "inline-block",
                        marginTop: "6px",
                        right: "2px",
                      }}
                    >
                      {localStorage.getItem("emailID")}
                    </span>
                       <br/>
                  Enter this OTP below and click on SUBMIT
                  </div>

                </div>

              )
            }

          </div>

          {/* OTP FIELD */}
          {
            !this.state.iconLoading && (

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "10px",
                    color: "#555",
                    textAlign: "center",
                  }}
                >
                  OTP
                </div>

                <TextField
                  text="text"
                  name="otp"
                  id="loginOtp"
                  maxLength="6"
                  autoComplete="off"
                  value={this.state.otp}
                  onChange={this.handelValidateOtp}
                  errorText={this.state.parsedErrors.otp}
                  style={{
                    width: "320px",
                    maxWidth: "100%",
                    background: "#F8FBFF",
                    border: "2px solid #D6E7FF",
                    borderRadius: "12px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  }}
                  underlineShow={false}
                  inputStyle={{
                    textAlign: "center",
                    fontSize: "26px",
                    fontWeight: "700",
                    letterSpacing: "8px",
                    height: "55px",
                    lineHeight: "55px",
                  }}
                  errorStyle={{
                    textAlign: "center",
                    color: "#ef4444",
                  }}
                />
              </div>

            )
          }

          {/* TIMER */}
          {
            !this.state.iconLoading && (

              <div style={s.timerRow}>

                {timer > 0 && (
                  <span style={s.timerText}>
                    Resend in {this.formatTime(timer)}
                  </span>
                )}

              </div>

            )
          }

          {/* RESEND */}
          {
            !this.state.iconLoading &&
            timer === 0 && (

              <div style={s.resendRow}>

                <button
                className="mt-4"
                  style={s.resendBtn}
                  onClick={this.handleResend}
                >
                  RESEND OTP
                </button>

              </div>

            )
          }

          {/* SUBMIT BUTTON */}
          {
            !this.state.iconLoading && (

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <RaisedButton
                  label="Submit"
                  backgroundColor="#007FFF"
  labelColor="#ffffff"
                  disabled={this.state.disabled}
                  onClick={this.handleSubmit}
                  buttonStyle={{
                    width: "320px",
                    height: "48px",
                    borderRadius: "6px",
                  }}
                />
              </div>

            )
          }

        </div>

      </div>

    );

  }

}

export default OtpPopup;


// WEBPACK FOOTER //
// ./src/components/otp/OtpPopup.js